var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.357,
    height: 9.656
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31379",
    d: "M6.188 5.431a1.019 1.019 0 00.691-.352L11.707.298a1.661 1.661 0 00-1.137-.3H1.641a1.413 1.413 0 00-1 .275l4.852 4.8a1 1 0 00.695.358zM.147 8.736l3.955-3.912L.147.924a1.8 1.8 0 00-.146.85v6.113a1.8 1.8 0 00.146.849zm1.641.92h8.93a1.461 1.461 0 001.007-.275L7.693 5.39l-.352.352a1.674 1.674 0 01-1.153.539 1.674 1.674 0 01-1.154-.539l-.357-.352L.656 9.375a1.754 1.754 0 001.132.281zm10.435-.926a1.914 1.914 0 00.135-.844V1.769a1.826 1.826 0 00-.141-.838L8.274 4.824z",
    fill: "#5f48e9"
  })));
}

export default SvgMessage;